export const LICENCE_CATEGORY = 'licence-category';
export const OTHER_DETAILS = 'other-details';
export const FOREIGN_COMPANY_DETAILS = 'foreign-company-details';
export const OPERATING_LOCATION = 'operating-location';
export const STATION_EQUIPMENT_INFORMATION = 'station-equipment-information';
export const TRIAL_INFORMATION = 'trial-information';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_TF_APPLICATION = [
    {
        sectionID: LICENCE_CATEGORY,
        sectionName: '',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'licence-category',
                label: 'Licence Category',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'proposed-used-of-system',
                label: 'Proposed use of System/Equipment',
                type: 'text'
            },
            {
                id: 'remarks-by-applicant',
                label: 'Remarks by Applicant (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FOREIGN_COMPANY_DETAILS,
        sectionName: 'Foreign Company Details',
        fieldList: [
            {
                id: 'foreign-company-name',
                label: 'Foreign Company Name',
                type: 'text'
            },
            {
                id: 'address-line-1',
                label: 'Address Line 1',
                type: 'text'
            },
            {
                id: 'address-line-2',
                label: 'Address Line 2',
                type: 'text'
            },
            {
                id: 'address-line-3',
                label: 'Address Line 3',
                type: 'text'
            },
            {
                id: 'address-line-4',
                label: 'Address Line 4',
                type: 'text'
            },
            {
                id: 'address-line-5',
                label: 'Address Line 5',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text'
            },
            {
                id: 'contact-number',
                label: 'Contact Number',
                type: 'text'
            },
            {
                id: 'city',
                label: 'City',
                type: 'text'
            },
            {
                id: 'state',
                label: 'State',
                type: 'text'
            },
            {
                id: 'zip-code',
                label: 'Zip Code',
                type: 'text'
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text'
            }
        ]
    },
    {
        sectionID: OPERATING_LOCATION,
        sectionName: 'Operating Location',
        fieldList: [
            {
                id: 'operating-location-list',
                label: '',
                type: 'table',
                subFields: [
                    {
                        id: 'no',
                        header: 'No.',
                        type: 'text'
                    },
                    {
                        id: 'building-name',
                        header: 'Building Name',
                        type: 'text'
                    },
                    {
                        id: 'street-name',
                        header: 'Street Name',
                        type: 'text'
                    },
                    {
                        id: 'block-house-no',
                        header: 'Block/House No.',
                        type: 'text'
                    },
                    {
                        id: 'floor-level',
                        header: 'Floor/Level',
                        type: 'text'
                    },
                    {
                        id: 'unit',
                        header: 'Unit',
                        type: 'text'
                    },
                    {
                        id: 'postal-code',
                        header: 'Postal Code',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: STATION_EQUIPMENT_INFORMATION,
        sectionName: 'Station/Equipment Information',
        fieldList: [
            {
                id: 'start-date',
                label: 'Start Date',
                type: 'text'
            },
            {
                id: 'end-date',
                label: 'End Date',
                type: 'text'
            },
            {
                id: 'station-equipment-name',
                label: 'Station/Equipment Name',
                type: 'text'
            },
            {
                id: 'purpose-and-objectives',
                label: 'Purpose and Objectives',
                type: 'text'
            }
        ]
    },
    {
        sectionID: TRIAL_INFORMATION,
        sectionName: 'Trial Information',
        fieldList: [
            {
                id: 'please-state-if-you-hold-radiocommunication-licences-issued-by-imda',
                label: 'Please state if you hold radiocommunication licences issued by IMDA',
                type: 'text',
                span: 12
            },
            {
                id: 'objective-of-the-proposed-trial',
                label: 'Objective of the proposed Trial',
                type: 'text',
                span: 12
            },
            {
                id: 'date-and-period-duration-of-the-proposed-trial',
                label: 'Date and Period/Duration of the proposed Trial',
                type: 'text',
                span: 12
            },
            {
                id: 'describe-the-role-identity-and-numbers-of-involved-parties',
                label: 'Describe the role, identity, and number of involved parties',
                type: 'text',
                span: 12
            },
            {
                id: 'describe-the-scope-and-feature-with-the-technical-commercial-parameters',
                label: 'Describe the scope and feature (with the technical/commercial parameters)',
                type: 'text',
                span: 12
            },
            {
                id: 'provide-the-system-configuration-that-will-be-used',
                label: 'Provide the system configuration that will be used',
                type: 'text',
                span: 12
            },
            {
                id: 'provide-the-location-and-geographic-coverage',
                label: 'Provide the location and geographic coverage',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
